import request from 'core/request'
import * as endpoints from 'core/endpoints'

/**
 * The gift catalog is the same for every conversation, so it is fetched once per page and shared.
 * ChatFooter keeps its own copy in component state for the gift picker; this is for everything that
 * renders outside it, such as a locked gift in the message thread.
 */
let pending = null

export const fetchGiftPrices = () => {
  if (!pending) {
    pending = request.get(endpoints.GIFT_PRICES)
      .then(response => JSON.parse(response.nameToPrice))
      .catch(error => {
        // Let the next caller retry rather than caching the failure forever.
        pending = null
        throw error
      })
  }

  return pending
}

/**
 * Gifts are addressed by the last two segments of their url, `<category>/<file>`, which is also how
 * ccp-api prices them. Keep the two in step.
 */
export const priceForGiftUrl = (prices, url) => {
  if (!prices || !url) {
    return null
  }

  const parts = String(url).split('?')[0].split('/').filter(Boolean)
  if (parts.length < 2) {
    return null
  }

  const [category, fileName] = parts.slice(-2)

  return prices[category]?.[fileName] ?? null
}

export const getGiftPrice = async url => priceForGiftUrl(await fetchGiftPrices(), url)

/** Testing seam - drops the cached catalog. */
export const resetGiftPrices = () => {
  pending = null
}
